import MobileInputLikeRow from './MobileInputLikeRow';

export default MobileInputLikeRow;
